<template>
    <div class="main custom card">
     <el-card>
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
            <el-form-item label="用户ID">
                <el-input v-model="userId" placeholder="userid/miniopenid"></el-input>
            </el-form-item>
            <el-form-item label="用户昵称">
                <el-input v-model="userName" placeholder="用户昵称"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="onSubmit">查询</el-button>
            </el-form-item>
        </el-form>
     </el-card>
     <el-card style="margin:10px 15px 0 15px" >
         <el-table
         :data="list"
          v-loading="loading"
        
         >
              <el-table-column
                prop="id"
                label="id">
              </el-table-column>
              <el-table-column prop="userId" label="用户Id"></el-table-column>
              <el-table-column prop="roleName" label="角色"></el-table-column>
              <el-table-column prop="userName" label="用户昵称"></el-table-column>
              <el-table-column prop="method" label="执行方法"></el-table-column>
              <el-table-column prop="methodName" label="方法名称"></el-table-column>
              <el-table-column prop="returnValue" label="返回值">
                    <template slot-scope="scope">
                             <p>{{ getReturnVal(scope.row)}}</p>
                    </template>
              </el-table-column>
              <el-table-column prop="executionTime" label="访问时间" width="140px">
                    <template slot-scope="scope">
                      {{formatTime(scope.row.executionTime)}}
                  </template>
              </el-table-column>
              <el-table-column prop="executionDuration" label="执行时长">
                  <template slot-scope="scope">
                      <p> {{scope.row.executionDuration}} ({{scope.row.executionDuration / 1000}}秒) </p>
                  </template>
              </el-table-column>
              <el-table-column prop="clientIpAddress" label="访问Ip"></el-table-column>
              <el-table-column prop="createTime" label="记录时间" width="140px">
                  <template slot-scope="scope">
                      {{formatTime(scope.row.createTime)}}
                  </template>
              </el-table-column>
         </el-table>
        <el-pagination
            style="float:right;margin:10px 15px 15px 0"
            layout="prev, pager, next"
            :page-sizes="[10, 20, 50, 100]"
            @current-change="handleCurrentChange"
            :page-size="pagination.pageSize"
            :total="pagination.total">
         </el-pagination>
     </el-card>
    </div>
</template>

<script>
import loginVue from "../../login.vue";
import { FormatTimes } from '@/utils/FormatTime'
export default {
	name: 'audit_list',
	props: [],
	data() {
		return {
		  pagination:{
              pageIndex:1,
              pageSize:10
          },
          list:[],
          userId:'',
          userName:'',
          loading:false
		}
	},
	watch: {},
	mounted: function() {},
    created: function() {
        this.getList()
    },
	methods: {
	  getList(){
          let $this = this
          $this.loading=true;
          this.axios.get('AuditLog',{
             params:{
                 pageIndex:$this.pagination.pageIndex,
                 pageSize:$this.pagination.pageSize,
                 userId:$this.userId,
                 userName:$this.userName
             }
          }).then(function({data})
          {
               $this.loading=false
               if(data.result){
                   $this.list= data.data.list
                   debugger
                   $this.pagination = data.data.pagination
               }else{
                   $this.$message(data.message);
               }
          })
      },
      getReturnVal(json){
        var obj = JSON.parse(json.returnValue)
        let {Data,...params} = obj
 
        if(params.Status==undefined){
            return "成功"
        }   
           return params;
      },
      onSubmit() {
          this.pagination.pageIndex=1
          this.getList()
      },
      handleCurrentChange(val){
          this.pagination.pageIndex=val
          this.getList()
      },
      formatTime(time) {
			 
			if (time == null) return '--'
			return FormatTimes(time, 'yyyy-MM-dd hh:mm:ss')
		}
	},
	components: {
 
	}
}
</script>

<style scoped>
  .card {
      margin: 10px 15px 0px;
    /* display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-flex: 1;
    -ms-flex: auto; */
    /* //height: calc(100vh - 200px); */
    overflow: auto;
  }
</style>


// WEBPACK FOOTER //
// src/components/manage/audit/list.vue